import { useLayoutEffect, useRef, useState, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Link, useLocation } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

gsap.registerPlugin(ScrollTrigger);

export default function ServiceDetailSlide({imgSlide}) {
  const location = useLocation();
  const containerRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  const [reloaderKey, setReloaderKey] = useState(0);

  const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, },
            },
        ],
    };

    const CustomArrows = () => (
        <>
            <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
                <Icons name="Longarrow_left" />
            </div>
            <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <Icons name="Longarrow_right" />
            </div>
        </>
    );


  useEffect(() => {
    setReloaderKey((prev) => prev + 1);
  }, [location.pathname]);

  useLayoutEffect(() => {
  const ctx = gsap.context(() => {
    const leftSections = gsap.utils.toArray(
      leftRef.current.querySelectorAll(":scope > div")
    );
    const rightContainer = rightRef.current;
    if (!leftSections.length || !rightContainer) return;

    const sectionCount = leftSections.length;

    const setInitialPositions = () => {
      const sectionHeight = window.innerHeight;
      gsap.set(rightContainer, {
        y: -sectionHeight * (sectionCount - 1),
      });
    };

    setInitialPositions();

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: () => `+=${sectionCount * window.innerHeight}`,
        pin: true,
        scrub: true,
        markers: false,
        invalidateOnRefresh: true,
      },
    });

    tl.to(leftSections, {
      yPercent: -100 * (sectionCount - 1),
      ease: "none",
    }).to(
      rightContainer,
      {
        y: 0,
        ease: "none",
      },
      0
    );

    const showWhenReady = () => {
      ScrollTrigger.refresh();
      containerRef.current.classList.add("is-ready");
    };

    const images = containerRef.current.querySelectorAll("img");
    let loadedCount = 0;
    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === images.length) showWhenReady();
        });
        img.addEventListener("error", () => {
          loadedCount++;
          if (loadedCount === images.length) showWhenReady();
        });
      }
    });
    if (loadedCount === images.length) showWhenReady();

    const onResize = () => {
      setInitialPositions();
      ScrollTrigger.refresh();
    };
    window.addEventListener("resize", onResize);

    // return a cleanup for event listeners that are not automatically handled by ctx
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, containerRef);

  // one refresh after mounting to ensure correct measurements
  const rafId = requestAnimationFrame(() => ScrollTrigger.refresh());

  return () => {
    cancelAnimationFrame(rafId);
    ctx.revert(); // this will kill only the triggers/timelines created inside this context
  };
}, [reloaderKey]);


  return (
    <>
    <section className="scroll-container" ref={containerRef}>
      <div className="sticky-container">

        <div className="left-side-col" ref={leftRef}>
          {imgSlide?.map((item, i) => (
            <div className="section-1-l" key={i}>
              <div className="bg-img-1">
                <img src={item.imageA} alt="service" loading="lazy" className="img-responsive"/>
              </div>
              <div className="content-parent">
                <span>{item.title}</span>
                <h4 className="heading">{item.name}</h4>
                <p>{item.para}</p>
                <Link to={item.link} className="default-btn"> {item.linktext} <Icons name="Longarrow_right"/>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="right-side-col" ref={rightRef}>
            {imgSlide?.slice().reverse().map((item, i) => (
              <div className="section-1-r" key={i}>
                <img src={item.imageB} alt="service" loading="lazy" className="img-responsive"/>
              </div>
            ))}
        </div>

      </div>
    </section>


    <section className="scrollslide-mobile">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                  <div className="scrollslider">
                    <Slider {...settings} ref={sliderRef} >
                        {imgSlide?.map((item, i) => (
                          <div className="section-1-l" key={i}>
                            <div className="bg-img-1">
                              <img src={item.imageA} alt="service" loading="lazy" className="img-responsive"/>
                            </div>
                            <div className="content-parent">
                              <span>{item.title}</span>
                              <label className="heading">{item.name}</label>
                              <p>{item.para}</p>
                              <Link to={item.link} className="default-btn"> {item.linktext} <Icons name="Longarrow_right"/>
                              </Link>
                            </div>
                          </div>
                        ))}
                    </Slider>
                    <CustomArrows />
                    </div>
                </div>
            </div>
        </div>      
    </section>
    </>
  );
}
